import { Outlet } from 'react-router-dom';
import FilterFormContextProvider from 'components/filters/FilterFormContextProvider';
import TriggersTabFilters from './filters/TriggersTabFilters';
import { TRIGGERS_TAB_FILTERS_LOCAL_STORAGE_KEY_PREFIX } from './filters/TriggersTabFilters.constants';
import {
  getFormDefaultValues,
  triggersTabFiltersSchema,
} from './filters/TriggersTabFilters.schema';
import TriggersTabHeader from './header/TriggersTabHeader';
import TriggersTable from './table/TriggersTable';

const TriggersTab = () => {
  return (
    <FilterFormContextProvider
      defaultValues={getFormDefaultValues()}
      localStorageKeyPrefix={TRIGGERS_TAB_FILTERS_LOCAL_STORAGE_KEY_PREFIX}
      schema={triggersTabFiltersSchema()}
    >
      <TriggersTabHeader>
        <TriggersTabFilters />
      </TriggersTabHeader>
      <TriggersTable />
      <Outlet />
    </FilterFormContextProvider>
  );
};

export default TriggersTab;
